import React from "react";
import PropTypes from "prop-types";
import styles from "./FeaturesList.module.css";
import Feature from "../Feature";

export default function FeaturesList({ features, colorBlue }) {
  const rows = features.reduce((accumulator, feature, index) => {
    const rowIndex = Math.floor(index / 3);
    if (!accumulator[rowIndex]) {
      accumulator[rowIndex] = [];
    }
    accumulator[rowIndex].push(feature);
    return accumulator;
  }, []);

  return (
    <>
      <div className={styles.container}>
        <h2>FEATURES</h2>
        {rows.map((row, rowIndex) => (
          <div key={rowIndex} className={styles.row}>
            {row.map((feature, colIndex) => (
              <div key={colIndex} className={styles.column}>
                <div
                  className={colorBlue === false ? styles.feature : undefined}
                >
                  <Feature
                    icon={feature.icon}
                    header={feature.header}
                    description={feature.description}
                    flip={feature.flip}
                  />
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
}

FeaturesList.propTypes = {
  features: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      header: PropTypes.string,
      description: PropTypes.string,
      flip: PropTypes.oneOf(["horizontal", "vertical"]),
    })
  ),
  colorBlue: PropTypes.bool,
};
